import React, { useEffect, useState } from 'react';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import random from 'lodash/random';
import { GridWrapper } from '@yme/atoms/grid';
import { useIsOnScreen } from '@yme/hooks/useIsOnScreen';
import { DigitalDataMutation, setDigitalData } from '@yme/utils/common';
import { IndentWrapper } from '../Separator';
import { ASPECT_RATIO_CARD_DEFAULT_PARAMS, HIGHLIGHTING_CARD_MAX_ROWS, gridSettings, } from '../pages/components/HighlightingCard/constants';
import { BANNER_A, BANNER_B, BANNER_COOKIE, BANNER_DD_KEY, EXPIRED_TIME } from './constants';
import { TeaserCardStyled } from './styled';
export function AbTestingBanner(props) {
    const { isRemoveBottomIndent, testId, isInEditor } = props;
    const currentBannerKey = `${BANNER_COOKIE}-${testId}`;
    const { isOnScreen, ref } = useIsOnScreen(0.75, '0px');
    const [isPageLoaded, setIsPageLoaded] = useState(false);
    const getRandomBannerFromStorage = localStorage.getItem(currentBannerKey) || '';
    const getCurrentBanner = () => {
        const tests = localStorage.getItem(BANNER_DD_KEY);
        const currentBanners = (!isEmpty(tests) && JSON.parse(tests || '{}')) || {};
        const currentBanner = get(currentBanners, currentBannerKey);
        return currentBanner?.banner;
    };
    const [banner, setBanner] = useState(getCurrentBanner() || '');
    if (isEmpty(getRandomBannerFromStorage)) {
        setBanner(random(1) === 0 ? BANNER_A : BANNER_B);
        localStorage.setItem(currentBannerKey, banner);
    }
    else {
        localStorage.setItem(currentBannerKey, getRandomBannerFromStorage);
    }
    useEffect(() => {
        if (document.readyState === 'complete') {
            setIsPageLoaded(true);
        }
    }, []);
    useEffect(() => {
        const tests = localStorage.getItem(BANNER_DD_KEY);
        const currentBanners = (!isEmpty(tests) && JSON.parse(tests || '{}')) || {};
        const currentBanner = get(currentBanners, currentBannerKey);
        if (!isEmpty(currentBanner) && currentBanner?.expired < Date.now()) {
            const randomBanner = random(1) === 0 ? BANNER_A : BANNER_B;
            setBanner(randomBanner);
            localStorage.setItem(currentBannerKey, randomBanner);
            localStorage.setItem(BANNER_DD_KEY, JSON.stringify(Object.assign({}, currentBanners || {}, {
                [currentBannerKey]: {
                    banner: randomBanner,
                    expired: Date.now() + EXPIRED_TIME,
                },
            })));
            setDigitalData(DigitalDataMutation.ABTEST_BANNER_VIEW, {
                [BANNER_DD_KEY]: {
                    [currentBannerKey]: randomBanner,
                },
            });
        }
        if (isOnScreen && isPageLoaded && isEmpty(currentBanner)) {
            localStorage.setItem(BANNER_DD_KEY, JSON.stringify(Object.assign({}, currentBanners || {}, {
                [currentBannerKey]: {
                    banner: banner || getRandomBannerFromStorage,
                    expired: Date.now() + EXPIRED_TIME,
                },
            })));
            setDigitalData(DigitalDataMutation.ABTEST_BANNER_VIEW, {
                [BANNER_DD_KEY]: {
                    [currentBannerKey]: banner,
                },
            });
        }
    }, [banner, currentBannerKey, getRandomBannerFromStorage, isOnScreen, isPageLoaded]);
    const onClickBannerButton = () => {
        setDigitalData(DigitalDataMutation.ABTEST_BANNER_CLICK, {
            [BANNER_DD_KEY]: {
                [currentBannerKey]: banner,
            },
        });
    };
    if (!isEmpty(testId)) {
        const banners = !isInEditor
            ? [get(props, banner) || get(props, getRandomBannerFromStorage)]
            : [props[BANNER_A], props[BANNER_B]];
        return (React.createElement(React.Fragment, null, map(banners, (ban) => (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
            React.createElement(GridWrapper, null,
                React.createElement("div", { ref: ref },
                    React.createElement(TeaserCardStyled, { image: ban?.image, title: ban?.title, description: ban?.description, subtitle: ban?.subtitle, button: ban?.button, aspectRatioParams: ASPECT_RATIO_CARD_DEFAULT_PARAMS, gridSettings: gridSettings, countLineVisible: HIGHLIGHTING_CARD_MAX_ROWS, onClick: onClickBannerButton }))))))));
    }
    return null;
}
AbTestingBanner.displayName = 'AbTestingBanner_AEMComponent';
